// ============================================================================
// oscOut.js — forward signals out over OSC
// ----------------------------------------------------------------------------
//   oscOut(addr:/obj/vel, v: map(fader.vel, 0, 500, 0, 1))
//       → /oscilla/obj/vel [v]
//   oscOut(addr:/obj, x: follow(a.x), y: follow(a.y), laps: follow(a.tvel), uid:s1)
//       → /oscilla/obj [x y vel]
//
// Every param except addr/uid is one argument, in the order written. A
// follow()/map() is followed and re-sent on every change; a plain number is a
// constant argument. Range and curve come from the follow() itself, so there is
// nothing to map here. Always on: registered at load, like oscCtrl.
// ============================================================================

import { bindParam } from "../control/paramBinding.js";
import { sendOSC } from "../system/oscillaOSCClient.js";
import { resolveAnimationUid } from "./animation.js";

const RESERVED = new Set(["addr", "uid"]);

export function handleOscOutCue(el, args = []) {
    const uid = resolveAnimationUid(el, "oscOut", args);
    const addr = args.find((a) => a.type === "addr")?.value;
    if (!addr) {
        console.error("[oscOut] addr missing", el);
        return;
    }

    const sigs = args.filter((a) => !RESERVED.has(a.type));
    const vals = new Array(sigs.length).fill(0);
    const fire = () => sendOSC({ type: "osc_value", addr: String(addr), args: vals.slice(), timestamp: Date.now() });

    // A source already on the bus answers at once; while binding, that only
    // fills its slot, and one message with every slot goes out after.
    let binding = true, primed = false;
    sigs.forEach(({ type: name, value }, i) => {
        // ponytail: one message per change; batch to one per frame if many args flap at once
        const b = bindParam(value, (v) => {
            vals[i] = v;
            if (binding) primed = true; else fire();
        }, { owner: `oscOut:${uid}:${name}` });
        vals[i] = b.value;
    });
    binding = false;
    if (primed) fire();
}
